// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"740":"TechView","1900":"IncomingView","5260":"TrainView"}[chunkId] || chunkId) + "." + {"740":"88fe9db6","1732":"3e40db1d","1900":"f50d050e","5260":"88fe9db6"}[chunkId] + ".chunk.css";
};